<template>
    <footer class="bg-light">
        <div class="container-fluid pt-4 pb-3 border-top text-center small">
          {{ copyRight() }}
        </div>
    </footer>
</template>

<script>
import {webmaster, websiteInfo} from '@/composable/staticData';

export default {
    data() {
        return {
            webmaster,
            websiteInfo,
            fullYear: new Date().getFullYear()
        }
    },
    methods: {
        copyRight() {
            return `©${this.fullYear} ${this.websiteInfo.name}`
        }
    }
}
</script>
